import stamp from '../images/stamp.png';
import logo from '../images/logo.png';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import React, { useRef, useState } from 'react';

// Thanks to SMK Solutions Medium post for the AppScripts section!
// https://medium.com/@shiddu/submitting-form-data-to-google-sheets-in-react-an-advanced-guide-25f0eefdde49

const ContactForm = () => {
      const [alert, setAlert] = useState(false);
      const [checkcont, setCheckcont] = useState('')
      function checkbox() {
          if (checkcont) {
            setCheckcont('');
          } else if (!checkcont) {
            setCheckcont('✔')
            setAlert(false);
          };
      }
    
      const [Name, setName] = useState(' ');
      const [Email, setEmail] = useState('');
      const [Info, setInfo] = useState('');
      const [sent, setSent] = useState(false)
      const formRef = useRef(null);
    
      function changeName(event) {
          setName(event.target.value);
      }
      function changeEmail(event) {
          setEmail(event.target.value);
      }
      function changeInfo(event) {
          setInfo(event.target.value);
      }
    
      const HandleSubmit = (e) => {
          if (checkcont === '✔') {
              e.preventDefault()
              const url = 'https://script.google.com/macros/s/AKfycbxgto4P71i1FXLkPaVhT3I24HLqcMCfExhpGXrh4PcFERIDllm_B80D-6rVFLlqgQwc/exec'
              fetch(url, {method:'POST',
                          body: new FormData(formRef.current),
              }).then(res=>res.json())
                .then(data=>{console.log(data);})
                .catch(err => console.log(err))
              setSent(true);
              setName('');
              setEmail('');
              setInfo('');
              setCheckcont('');
              setTimeout(() => {
                  setSent(false);
              }, 3000)
          } else {
              e.preventDefault();
              setAlert(true);
          }
      }
    
  return (
      <div className="page">
      {
        sent &&
        <div className='confirm'>
            <p>Message Sent</p>
        </div>
      }
        <h1>Bunny's Bakes</h1>
        <div className='logo-cont'>
            <img src={logo} className='logo' alt='Bunny\'s Bakes Logo/>
        </div>
        <img src={stamp} className='stamp' alt='stamp with a rabbit that reads more coming soon'/>
        <div className="contact">
            <Form ref={formRef} onSubmit={HandleSubmit}>
                <Form.Group className="input-cont">                        
                        <Form.Label for="name" className='label'>Name</Form.Label>
                        <Form.Control type="text" name='Name' className="input name" onChange={changeName} value={Name} required/>
                        <br/>
                     <Form.Group className="contact-cont">   
                        <Form.Group className='contact-side-one'>
                        <Form.Label for="email" className='label'>Email</Form.Label>
                        <Form.Control type="email" name='Email' className="input email" onChange={changeEmail} value={Email} required/>  
                      </Form.Group>
                        <Form.Group className='contact-side-two'>
                        <br/>
                        <Form.Label for="date">Date of Event</Form.Label>
                        <Form.Control type="date" name='Date' className="date" />
                        </Form.Group>
                     </Form.Group>
                    <br/>
                    <Form.Label for="info">Order Info</Form.Label>
                    <Form.Control as='textarea' rows={3} name='Info' className="input info" onChange={changeInfo} value={Info} required/>
                    <br/>
                    <div className='cb'>
                        <Form.Control type='button' name='check' className='check' value={checkcont} onClick={checkbox} required></Form.Control>
                        <p>I understand that submitting this form does not mean that my event has been confirmed.</p>
                    </div>
                {
                    alert &&
                    <p className='alert'>You must confirm that submitting this form does not equal a confirmation of services.</p>
                }
                </Form.Group>
                <Form.Group className="sub-cont">
                    <Button className="sub-button" type='submit'>Send</Button>
                </Form.Group>
            </Form>
        </div>
      </div>
  );
};


export default ContactForm;